import React from "react";
import { useNavigate } from "react-router-dom";
import WorldsOverview from "../components/learn/maps/WorldsOverview";
import useLearnProgress from "../hooks/useLearnProgress";
import { useLearnCloudNavigate } from "../components/learn/PixleyCloudTransition";
import { LEARN } from "../components/learn/theme";
import {
  ALPHABET_WORLDS, LETTERS, LETTER_LESSONS, isWorldUnlocked, letterChipState, worldForCompletedCount,
} from "../utils/learnLetterProgress";

const T = LEARN.course.letters;

export default function AlphabetWorldsPage() {
  const navigate = useNavigate();
  const { navigateWithCloud } = useLearnCloudNavigate();
  const { completedLetterCount, nextLetter, loading } = useLearnProgress();
  const currentWorld = worldForCompletedCount(completedLetterCount);

  const openWorld = (world) => {
    if (!isWorldUnlocked(world.id, completedLetterCount)) return;
    navigateWithCloud(`/learn/letters/${world.id}`);
  };

  const worlds = ALPHABET_WORLDS.map((w) => {
    const unlocked = isWorldUnlocked(w.id, completedLetterCount);
    const done = w.letters.filter((L) => LETTERS.indexOf(L) < completedLetterCount).length;
    const state = !unlocked ? "locked" : done === w.letters.length ? "complete" : w.id === currentWorld.id ? "current" : "open";
    return {
      id: w.id,
      title: w.title,
      subtitle: `Letters ${w.letters[0]}–${w.letters[w.letters.length - 1]}`,
      art: w.overviewArt,
      state,
      chips: w.letters.map((L) => ({ label: L, state: letterChipState(L, completedLetterCount) })),
      note: `Finish ${ALPHABET_WORLDS[ALPHABET_WORLDS.indexOf(w) - 1]?.title || "the world before"} first`,
      onOpen: () => openWorld(w),
    };
  });

  const worldsDone = worlds.filter((w) => w.state === "complete").length;

  return (
    <WorldsOverview
      eyebrow="Letters"
      title="Alphabet Worlds"
      accent={T.accent}
      accentDeep={T.deep}
      progress={{ done: completedLetterCount, total: LETTERS.length, unit: "letters" }}
      loading={loading}
      resume={{
        title: nextLetter ? `Letter ${nextLetter}` : "All 26 letters done!",
        subtitle: nextLetter ? `${currentWorld.title} · ${LETTER_LESSONS[nextLetter]?.length || 0} little games` : "Every world is open to play again.",
        cta: nextLetter ? (completedLetterCount > 0 ? "Continue" : "Start") : "Explore",
        art: currentWorld.overviewArt,
        onStart: () => openWorld(currentWorld),
      }}
      worlds={worlds}
      onBack={() => navigate("/learn")}
      key={worldsDone}
    />
  );
}
